/**
 * @ngdoc directive
 * @param ShareService
 * @returns {{restrict: string, link: Function}}
 * @param Alerts
 */
export default function shareDirective(ShareService, Alerts) {
  'ngInject';
  return {
    restrict: 'A',
    /**
     * @description Assigns the correct action for the click event based on the attrs object. e.g. If twitter is present then use the twitter action.
     * @param $scope
     * @param $element
     * @param $attrs
     */
    link: function ($scope, $element, $attrs) {
      //Get the network symbol
      let networkName = $attrs.share;
      //The actions to complete after the sharing is finished.
      function shareSuccess() {
        Alerts.add({
          type: 'success',
          message: `${networkName} share successful.`
        });
      }

      function shareError() {
        Alerts.add({
          type: 'danger',
          message: `There has been an error sharing to ${networkName}.`
        });
      }

      //Make sure we have this network in our api.
      if (networkName in ShareService) {
        let network = ShareService[networkName];
        let {photo, caption, text} = $attrs;
        //Create the message from composed attrs.
        let message = {
          text,
          photo,
          caption
        };
        //Add click handler.
        $element.on('click', function () {
          //Send data to the social network.
          network.post(message).then(shareSuccess, shareError);
        });
      }
      //The network does not exist in our api. Error and do nothing.
      else {
        //TODO - MED - Error
        console.error('Social Network not present in Share Service.');
      }
    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/components/share/share.directive.js
 **/